module.exports = __webpack_public_path__ + "img/img-chuanyuan-s3.00c83e00.jpg";